import React from 'react'
import "../CSS/Design.css"


function Steps() {


  
  

  return (
    
    <div>
<div className="iconHead text-light py-4" >
      <div className="row text-center text-white">
  <h3 className='text-white'>The Easy 3 steps</h3>
      </div>
      
      </div>
 
 <div className="icons" >
  <div className=" mb-5">
    <div className="row text-center ">
      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-5">
        <img src="https://w7.pngwing.com/pngs/247/564/png-transparent-computer-icons-user-profile-user-avatar-blue-heroes-electric-blue.png" width="200px" height="200px"/>
       <h4 className="mt-3">The user</h4> 
      </div>
      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-5">
        <img src="https://w7.pngwing.com/pngs/247/564/png-transparent-computer-icons-user-profile-user-avatar-blue-heroes-electric-blue.png" width="200px" height="200px"/>
        <h4 className="mt-3">The drone</h4> 
      </div>
      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-5">
        <img src="https://w7.pngwing.com/pngs/247/564/png-transparent-computer-icons-user-profile-user-avatar-blue-heroes-electric-blue.png" width="200px" height="200px"/>
        <h4 className="mt-3">The cloud</h4> 
        
      </div>
    </div>
  </div>
 </div>

    </div>
  
  )
}

export default Steps ;